import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import BlueLogo from "./BlueLogo";

const NAV = [
  { id: "how", label: "How it Works" },
  { id: "tiers", label: "Tiers" },
  { id: "slab", label: "The Slab" },
  { id: "faq", label: "FAQ" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button onClick={() => scrollTo("top")} data-testid="header-logo" className="shrink-0">
          <BlueLogo size="sm" />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              data-testid={`nav-${n.id}`}
              className="font-display text-sm font-medium text-white/70 hover:text-brand transition-colors tracking-wide"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <button onClick={() => scrollTo("submit")} data-testid="header-cta-submit" className="btn-primary !py-3 !px-6 text-xs">
            Start Submission
          </button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-white/5" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => scrollTo(n.id)}
                data-testid={`mobile-nav-${n.id}`}
                className="text-left font-display text-base text-white/80 hover:text-brand"
              >
                {n.label}
              </button>
            ))}
            <button onClick={() => scrollTo("submit")} data-testid="mobile-cta-submit" className="btn-primary justify-center mt-2">
              Start Submission
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
